"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignStatus.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);







var _broadcast = require('shared/selectors/broadcast');
var _time = require('shared/services/time');
var _campaignRecipientsAdd = require('shared/services/campaignRecipientsAdd');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _hooks = require('web/services/hooks');
var _format = require('./format');
var _campaignState = require('./campaignState');
var _useCampaignSchedule = require('./useCampaignSchedule'); var _useCampaignSchedule2 = _interopRequireDefault(_useCampaignSchedule);
var _addingRecipients = require('./addingRecipients');








const CampaignStatus = ({ campaignKey, className, isCompact }) => {
  const isActive = _hooks.useAppSelector.call(void 0, state => _broadcast.selectIsCampaignActive.call(void 0, state, campaignKey))
  const totalPatientsCount = _hooks.useAppSelector.call(void 0, 
    state => _broadcast.selectCampaignTotalPatientsCount.call(void 0, state, campaignKey),
  )
  const stats = _hooks.useAppSelector.call(void 0, state => _broadcast.selectCampaignStats.call(void 0, state, campaignKey))
  const createdAt = _hooks.useAppSelector.call(void 0, 
    state => _nullishCoalesce(_optionalChain([_broadcast.selectCampaignByKey.call(void 0, state, campaignKey), 'optionalAccess', _ => _.CreatedAt]), () => ( '')),
  )

  // A campaign is a draft until the wizard saves its message.
  const isDraft = _hooks.useAppSelector.call(void 0, state => !_optionalChain([_broadcast.selectCampaignByKey.call(void 0, state, campaignKey), 'optionalAccess', _2 => _2.MessageTemplate]))
  const isPaused = _hooks.useAppSelector.call(void 0, state => {
    const campaign = _broadcast.selectCampaignByKey.call(void 0, state, campaignKey)
    return !!campaign && _campaignState.isPausedCampaign.call(void 0, campaign)
  })

  const dateSuffix = _time.formatDisplayDate.call(void 0, createdAt)
  // Rev 27 P2: a send for later reads Scheduled until its time.
  const schedule = _useCampaignSchedule2.default.call(void 0, campaignKey)
  const startsAt = schedule.startAt && _format.formatSendTime.call(void 0, schedule.startAt, { weekday: !isCompact })
  // P2' (Q2): the latest background Add.
  const add = _addingRecipients.useRecipientsAdd.call(void 0, campaignKey)

  if (schedule.state === 'scheduled') {
    return (
      _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, "campaign-status campaign-status--scheduled", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}, "Scheduled · "
          ,  startsAt 
      )
    )
  }

  // Until the start time is read, it may yet be Scheduled: say only that
  // it's on (review R800-38).
  if (isActive && !schedule.isKnown) {
    return (
      _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, "campaign-status campaign-status--active", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}, "Active ("
         ,  stats.completed , "/",  totalPatientsCount , ")"
      )
    )
  }

  if (isActive) {
    return (
      _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, "campaign-status campaign-status--active", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, "Running ("
         ,  stats.completed , "/",  totalPatientsCount , ")"
      )
    )
  }

  // P2' (Q2): while recipients are being added, that replaces Draft, Not
  // yet sent and Paused: a percentage in the header, rows in the list.
  if (_optionalChain([add, 'optionalAccess', _3 => _3.State]) === 'running') {
    return (
      _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, "campaign-status campaign-status--adding", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}
        ,  isCompact
          // The first push comes before the file's rows are counted.
          ? add.TotalRows > 0 ? `Adding ${_format.formatCount.call(void 0, add.RowsDone)} of ${_format.formatCount.call(void 0, add.TotalRows)}` : 'Adding recipients…'
          : `Adding recipients · ${_campaignRecipientsAdd.addPercent.call(void 0, add)}%` 
      )
    )
  }
  // An Add that ended early: the list row says so until the next change.
  if (isCompact && add && _campaignRecipientsAdd.isAddStopped.call(void 0, add.State)) {
    return (
      _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, "campaign-status campaign-status--fail", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}, "Adding stopped"

      )
    )
  }

  // Rev 33 T2: Paused is the only stopped state.
  if (isPaused) {
    return (
      _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, "campaign-status campaign-status--inactive", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}, "Paused · "
          ,  _format.formatCount.call(void 0, stats.completed) , " of "  ,  _format.formatCount.call(void 0, totalPatientsCount) , " sent"
      )
    )
  }

  if (isDraft) {
    return (
      _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, "campaign-status campaign-status--inactive", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}, "Draft · not yet sent"

      )
    )
  }

  // Nothing has gone out yet (or a pause came before the first message).
  if (_campaignState.campaignAttemptedCount.call(void 0, stats) === 0) {
    return (
      _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, "campaign-status campaign-status--inactive", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}}, "Not yet sent"

      )
    )
  }

  // Rev 28 Q3: nothing is left to send (display only). Recipients waiting
  // for consent don't hold it open: each one's text goes when they reply YES.
  return (
    _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, "campaign-status campaign-status--done", className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}, "Completed ("
       ,  stats.completed , "/",  totalPatientsCount , ") · "  ,  dateSuffix 
    )
  )
}

exports. default = _react.memo.call(void 0, CampaignStatus)
